module.exports = __webpack_public_path__ + "static/media/facebook-f.eeb1b06c.svg";